// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-page {
  min-width: 0;
  color: var(--text);
}

.info-toolbar {
  margin-top: 0;
}

.info-toolbar__version {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eef4ff;
  color: #415779;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1;
}

.info-shell {
  --info-ink: #10284a;
  --info-ink-deep: #07172e;
  --info-blue: #1759ad;
  --info-blue-soft: #eaf2ff;
  --info-orange: #f0a23a;
  display: grid;
  width: 100%;
  max-width: none;
  min-width: 0;
  gap: 64px;
  margin: 0;
  padding: 18px 18px 42px;
  border: 1px solid #dce4ef;
  border-radius: 26px;
  background: #ffffff;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);
  overflow: hidden;
}

.info-hero {
  position: relative;
  isolation: isolate;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(360px, 0.92fr);
  gap: 28px;
  padding: 48px;
  border-radius: 20px;
  color: #ffffff;
  background:
    radial-gradient(circle at 10% 15%, rgba(64, 139, 238, 0.34), transparent 32%),
    radial-gradient(circle at 88% 82%, rgba(240, 162, 58, 0.2), transparent 29%),
    linear-gradient(132deg, var(--info-ink) 0%, var(--info-ink-deep) 72%);
  overflow: hidden;
  animation: info-rise 420ms ease-out both;
}

.info-hero::before,
.info-hero::after {
  position: absolute;
  z-index: -1;
  width: 250px;
  height: 250px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 50%;
  content: "";
}

.info-hero::before {
  top: -150px;
  right: 26%;
  box-shadow:
    0 0 0 46px rgba(255, 255, 255, 0.025),
    0 0 0 92px rgba(255, 255, 255, 0.018);
}

.info-hero::after {
  right: -140px;
  bottom: -165px;
  box-shadow: 0 0 0 58px rgba(240, 162, 58, 0.04);
}

.info-hero__copy {
  align-self: center;
  max-width: 760px;
}

.info-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--info-blue);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  line-height: 1.3;
  text-transform: uppercase;
}

.info-eyebrow--light {
  color: #91bcf5;
}

.info-hero h1 {
  max-width: 720px;
  margin: 14px 0 18px;
  color: #ffffff;
  font-size: clamp(2.25rem, 4vw, 4.5rem);
  font-weight: 700;
  letter-spacing: -0.055em;
  line-height: 0.98;
}

.info-hero__lead {
  max-width: 690px;
  margin: 0;
  color: #dce9f9;
  font-size: 1.05rem;
  line-height: 1.75;
}

.info-principles {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 28px;
}

.info-principles span {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  gap: 9px;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  color: #f7fbff;
  font-size: 0.78rem;
  font-weight: 700;
  backdrop-filter: blur(8px);
}

.info-principles svg {
  color: #81b7fa;
}

.info-topology {
  align-self: stretch;
  margin: 0;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.075);
  backdrop-filter: blur(12px);
}

.info-topology figcaption {
  display: grid;
  gap: 4px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.info-topology figcaption span {
  color: #96aeca;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.info-topology figcaption strong {
  color: #ffffff;
  font-size: 1.1rem;
}

.info-topology__rail {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 16px 0 12px;
  list-style: none;
}

.info-topology__rail li {
  position: relative;
  display: grid;
  grid-template-columns: 28px 38px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-height: 58px;
}

.info-topology__rail li:not(:last-child)::after {
  position: absolute;
  top: 49px;
  bottom: -9px;
  left: 46px;
  width: 1px;
  background: linear-gradient(#6ba6ee, rgba(107, 166, 238, 0.16));
  content: "";
}

.info-topology__number {
  color: #7690ae;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.info-topology__icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 11px;
  background: #17365f;
  color: #90c0ff;
}

.info-topology__text {
  display: grid;
  gap: 2px;
}

.info-topology__text strong {
  color: #ffffff;
  font-size: 0.86rem;
}

.info-topology__text small {
  color: #aebfd3;
  font-size: 0.72rem;
  line-height: 1.45;
}

.info-topology > p {
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: #b9c9db;
  font-size: 0.72rem;
  line-height: 1.6;
}

.info-status {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 2px 0 0;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.065);
  overflow: hidden;
}

.info-status > div {
  min-width: 0;
  padding: 16px 18px;
}

.info-status > div + div {
  border-left: 1px solid rgba(255, 255, 255, 0.12);
}

.info-status dt {
  margin-bottom: 6px;
  color: #91a8c3;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.info-status dd {
  margin: 0;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.info-status__code {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
  font-size: 0.78rem !important;
}

.info-index {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: -38px 28px -20px;
  padding: 10px;
  border: 1px solid #dce4ef;
  border-radius: 14px;
  background: #f8fafc;
}

.info-index > span {
  padding: 8px 12px;
  color: #64748b;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.info-index a {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  padding: 8px 13px;
  border-radius: 9px;
  color: #31445f;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
  transition: background 150ms ease, color 150ms ease;
}

.info-index a:hover {
  background: #eaf2ff;
  color: #1759ad;
}

.info-section {
  min-width: 0;
  padding: 0 28px;
  scroll-margin-top: 18px;
}

.info-section-heading {
  max-width: 900px;
  margin-bottom: 24px;
}

.info-section-heading h2,
.info-flow h2 {
  margin: 8px 0 10px;
  color: var(--info-ink-deep);
  font-size: clamp(1.65rem, 2.6vw, 2.65rem);
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1.1;
}

.info-section-heading > p {
  max-width: 780px;
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.7;
}

.info-tool-groups {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.info-tool-group {
  min-width: 0;
  padding: 22px;
  border: 1px solid #dce4ef;
  border-radius: 18px;
  background: #fbfdff;
}

.info-tool-group > header {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 14px;
  min-height: 84px;
  padding: 0 2px 18px;
  border-bottom: 1px solid #e5ebf3;
}

.info-tool-group__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: #eaf2ff;
  color: #1759ad;
  font-size: 1rem;
}

.info-tool-group h3 {
  margin: 1px 0 5px;
  color: #122b4e;
  font-size: 1rem;
}

.info-tool-group header p {
  margin: 0;
  color: #64748b;
  font-size: 0.76rem;
  line-height: 1.55;
}

.info-tool-group ul {
  display: grid;
  gap: 4px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.info-tool-link {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 22px;
  min-height: 62px;
  align-items: center;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 11px;
  color: inherit;
  text-decoration: none;
  transition: background 150ms ease, transform 150ms ease;
}

.info-tool-link:hover {
  background: #ffffff;
  transform: translateX(2px);
}

.info-tool-link__icon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid #dfe7f1;
  border-radius: 10px;
  background: #ffffff;
  color: #3f5b7f;
}

.info-tool-link__copy {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.info-tool-link__copy strong {
  color: #10284a;
  font-size: 0.82rem;
}

.info-tool-link__copy small {
  color: #6d7d91;
  font-size: 0.68rem;
  line-height: 1.4;
}

.info-tool-link__arrow {
  justify-self: center;
  color: #94a3b8;
  font-size: 0.72rem;
  transition: color 150ms ease, transform 150ms ease;
}

.info-tool-link:hover .info-tool-link__arrow {
  color: #1759ad;
  transform: translateX(2px);
}

.info-applications {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.info-application {
  display: grid;
  grid-template-columns: 142px minmax(0, 1fr);
  min-height: 190px;
  border: 1px solid #dce4ef;
  border-radius: 18px;
  background: #ffffff;
  color: inherit;
  text-decoration: none;
  overflow: hidden;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.info-application:first-child {
  grid-column: 1 / -1;
  grid-template-columns: minmax(190px, 0.55fr) minmax(0, 1.45fr);
}

.info-application:hover {
  border-color: #a9c7ec;
  box-shadow: 0 14px 30px rgba(23, 89, 173, 0.1);
  transform: translateY(-2px);
}

.info-application__visual {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px;
  background:
    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.28), transparent 24%),
    linear-gradient(145deg, #225f99, #123d69);
  color: #ffffff;
  overflow: hidden;
}

.info-application:nth-child(2) .info-application__visual {
  background:
    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.28), transparent 24%),
    linear-gradient(145deg, #2f8069, #175242);
}

.info-application:nth-child(3) .info-application__visual {
  background:
    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.24), transparent 24%),
    linear-gradient(145deg, #2466ae, #123c75);
}

.info-application:nth-child(4) .info-application__visual {
  background:
    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.26), transparent 24%),
    linear-gradient(145deg, #b85e3f, #793725);
}

.info-application:nth-child(5) .info-application__visual {
  background:
    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.26), transparent 24%),
    linear-gradient(145deg, #5c638d, #333958);
}

.info-application__visual::after {
  position: absolute;
  right: -38px;
  bottom: -56px;
  width: 135px;
  height: 135px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  box-shadow: 0 0 0 26px rgba(255, 255, 255, 0.04);
  content: "";
}

.info-application__visual > svg {
  position: relative;
  z-index: 1;
  font-size: 1.75rem;
}

.info-application__visual small {
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 0.83);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  line-height: 1.45;
  text-transform: uppercase;
}

.info-application__body {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 24px;
}

.info-application__title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.info-application__title strong {
  color: #0b203c;
  font-size: 1rem;
}

.info-application__title svg {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 0.72rem;
  transition: color 150ms ease, transform 150ms ease;
}

.info-application:hover .info-application__title svg {
  color: #1759ad;
  transform: translateX(2px);
}

.info-application__description {
  margin-top: 10px;
  color: #56677c;
  font-size: 0.76rem;
  line-height: 1.65;
}

.info-application__data {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: auto;
  padding-top: 15px;
  color: #46617f;
  font-size: 0.66rem;
  font-weight: 700;
  line-height: 1.45;
}

.info-application__data svg {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #3a78c2;
}

.info-flow {
  display: grid;
  grid-template-columns: minmax(260px, 0.72fr) minmax(0, 1.28fr);
  gap: 42px;
  margin: 0 28px;
  padding: 40px;
  border-radius: 20px;
  color: #ffffff;
  background:
    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px),
    #0c213e;
  background-size: 32px 32px;
  scroll-margin-top: 18px;
}

.info-flow__intro {
  align-self: start;
  position: sticky;
  top: 18px;
}

.info-flow h2 {
  margin-top: 10px;
  color: #ffffff;
}

.info-flow__intro p {
  margin: 0;
  color: #b8c8dc;
  font-size: 0.8rem;
  line-height: 1.7;
}

.info-flow__steps {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.info-flow__steps li {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 18px;
  padding: 19px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.11);
}

.info-flow__steps li:first-child {
  padding-top: 0;
}

.info-flow__steps li:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.info-flow__number {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(131, 184, 251, 0.35);
  border-radius: 12px;
  background: rgba(76, 142, 224, 0.12);
  color: #8dc0ff;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.info-flow__steps h3 {
  margin: 1px 0 5px;
  color: #ffffff;
  font-size: 0.9rem;
}

.info-flow__steps p {
  margin: 0;
  color: #b8c8dc;
  font-size: 0.72rem;
  line-height: 1.6;
}

.info-boundaries {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #dce4ef;
  border-radius: 18px;
  overflow: hidden;
}

.info-boundaries article {
  position: relative;
  min-width: 0;
  padding: 26px;
  background: #ffffff;
}

.info-boundaries article + article {
  border-left: 1px solid #dce4ef;
}

.info-boundaries article:nth-child(odd) {
  border-left: 0;
}

.info-boundaries article:nth-child(n + 3) {
  border-top: 1px solid #dce4ef;
}

.info-boundaries__icon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
  border-radius: 12px;
  background: #eaf2ff;
  color: #1759ad;
}

.info-boundaries__label {
  display: block;
  margin-bottom: 6px;
  color: #6782a3;
  font-size: 0.63rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.info-boundaries h3 {
  margin: 0 0 10px;
  color: #10284a;
  font-size: 1rem;
}

.info-boundaries p {
  margin: 0;
  color: #64748b;
  font-size: 0.72rem;
  line-height: 1.65;
}

.info-privacy-note {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 14px;
  margin-top: 14px;
  padding: 18px 20px;
  border: 1px solid #cfe0f5;
  border-radius: 14px;
  background: #f2f7fd;
  color: #10284a;
}

.info-privacy-note > svg {
  justify-self: center;
  margin-top: 2px;
  color: #1759ad;
  font-size: 1rem;
}

.info-privacy-note strong {
  font-size: 0.8rem;
}

.info-privacy-note p {
  margin: 4px 0 0;
  color: #59708d;
  font-size: 0.7rem;
  line-height: 1.55;
}

.info-scope {
  display: grid;
  grid-template-columns: minmax(220px, 0.45fr) minmax(0, 1.55fr);
  gap: 28px;
  margin-top: 14px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fbfcfe;
}

.info-scope__heading h3 {
  margin: 8px 0 0;
  color: #10284a;
  font-size: 1rem;
  line-height: 1.35;
}

.info-scope ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 24px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.info-scope li {
  position: relative;
  padding-left: 17px;
  color: #607188;
  font-size: 0.69rem;
  line-height: 1.6;
}

.info-scope li::before {
  position: absolute;
  top: 0.65em;
  left: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3f7fc9;
  content: "";
}

.info-section--terms {
  padding-bottom: 12px;
}

.info-glossary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  border-top: 1px solid #dce4ef;
  border-left: 1px solid #dce4ef;
}

.info-glossary > div {
  min-width: 0;
  min-height: 142px;
  padding: 22px;
  border-right: 1px solid #dce4ef;
  border-bottom: 1px solid #dce4ef;
  background: #ffffff;
}

.info-glossary dt {
  margin-bottom: 9px;
  color: #10284a;
  font-size: 0.92rem;
  font-weight: 800;
}

.info-glossary dd {
  margin: 0;
  color: #64748b;
  font-size: 0.7rem;
  line-height: 1.65;
}

.info-page a:focus-visible {
  outline: 3px solid rgba(59, 130, 246, 0.36);
  outline-offset: 3px;
}

@keyframes info-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1180px) {
  .info-hero {
    grid-template-columns: 1fr;
  }

  .info-topology__rail {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
  }

  .info-topology__rail li {
    grid-template-columns: 32px minmax(0, 1fr);
    grid-template-rows: auto auto;
    align-content: start;
    min-height: 110px;
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
  }

  .info-topology__rail li::after {
    display: none;
  }

  .info-topology__number {
    grid-column: 1 / -1;
  }

  .info-topology__text small {
    margin-top: 2px;
  }
}

@media (max-width: 960px) {
  .info-shell {
    gap: 52px;
  }

  .info-hero {
    padding: 36px;
  }

  .info-status {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .info-status > div:nth-child(3) {
    border-left: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }

  .info-status > div:nth-child(4) {
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }

  .info-tool-groups,
  .info-applications,
  .info-flow {
    grid-template-columns: 1fr;
  }

  .info-application:first-child {
    grid-column: auto;
    grid-template-columns: 142px minmax(0, 1fr);
  }

  .info-flow__intro {
    position: static;
  }

  .info-boundaries,
  .info-glossary {
    grid-template-columns: 1fr;
  }

  .info-scope {
    grid-template-columns: 1fr;
  }

  .info-boundaries article + article {
    border-top: 1px solid #dce4ef;
    border-left: 0;
  }

  .info-glossary > div {
    min-height: auto;
  }
}

@media (max-width: 720px) {
  .info-shell {
    gap: 42px;
    padding: 10px 10px 30px;
    border-radius: 20px;
  }

  .info-hero {
    gap: 20px;
    padding: 26px;
    border-radius: 15px;
  }

  .info-hero h1 {
    font-size: clamp(2rem, 11vw, 3.25rem);
  }

  .info-principles {
    align-items: flex-start;
    flex-direction: column;
  }

  .info-topology__rail {
    grid-template-columns: 1fr;
  }

  .info-topology__rail li {
    grid-template-columns: 28px 38px minmax(0, 1fr);
    grid-template-rows: auto;
    min-height: 58px;
    padding: 6px 0;
    border: 0;
  }

  .info-topology__number {
    grid-column: auto;
  }

  .info-index {
    margin: -24px 12px -12px;
  }

  .info-index > span {
    width: 100%;
  }

  .info-section {
    padding: 0 12px;
  }

  .info-flow {
    gap: 30px;
    margin: 0 12px;
    padding: 28px;
  }

  .info-tool-group {
    padding: 16px;
  }

  .info-scope ul {
    grid-template-columns: 1fr;
  }

  .info-application,
  .info-application:first-child {
    grid-template-columns: 112px minmax(0, 1fr);
  }

  .info-application__visual,
  .info-application__body {
    padding: 18px;
  }
}

@media (max-width: 480px) {
  .info-status {
    grid-template-columns: 1fr;
  }

  .info-status > div + div,
  .info-status > div:nth-child(3) {
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    border-left: 0;
  }

  .info-topology {
    padding: 18px;
  }

  .info-application,
  .info-application:first-child {
    grid-template-columns: 1fr;
  }

  .info-application__visual {
    min-height: 112px;
  }

  .info-application__visual small {
    margin-top: 22px;
  }

  .info-tool-group > header {
    grid-template-columns: 1fr;
  }

  .info-tool-link {
    grid-template-columns: 34px minmax(0, 1fr);
  }

  .info-tool-link__arrow {
    display: none;
  }

  .info-flow__steps li {
    grid-template-columns: 42px minmax(0, 1fr);
    gap: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .info-hero {
    animation: none;
  }

  .info-index a,
  .info-tool-link,
  .info-tool-link__arrow,
  .info-application,
  .info-application__title svg {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Info.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd;;;yEAGuE;EACvE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV;;yCAEuC;AACzC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,UAAU;EACV,+DAA+D;EAC/D,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qEAAqE;EACrE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb;;6CAE2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;;6CAE2C;AAC7C;;AAEA;EACE;;6CAE2C;AAC7C;;AAEA;EACE;;6CAE2C;AAC7C;;AAEA;EACE;;6CAE2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd;;;WAGS;EACT,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;EACN,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,0CAA0C;IAC1C,6BAA6B;IAC7B,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,cAAc;IACd,+CAA+C;EACjD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+CAA+C;IAC/C,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2CAA2C;EAC7C;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,+CAA+C;IAC/C,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0CAA0C;IAC1C,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,gBAAgB;EAClB;AACF","sourcesContent":[".info-page {\n  min-width: 0;\n  color: var(--text);\n}\n\n.info-toolbar {\n  margin-top: 0;\n}\n\n.info-toolbar__version {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 10px;\n  border: 1px solid #dbeafe;\n  border-radius: 999px;\n  background: #eef4ff;\n  color: #415779;\n  font-size: 0.75rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.info-shell {\n  --info-ink: #10284a;\n  --info-ink-deep: #07172e;\n  --info-blue: #1759ad;\n  --info-blue-soft: #eaf2ff;\n  --info-orange: #f0a23a;\n  display: grid;\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  gap: 64px;\n  margin: 0;\n  padding: 18px 18px 42px;\n  border: 1px solid #dce4ef;\n  border-radius: 26px;\n  background: #ffffff;\n  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);\n  overflow: hidden;\n}\n\n.info-hero {\n  position: relative;\n  isolation: isolate;\n  display: grid;\n  grid-template-columns: minmax(0, 1.08fr) minmax(360px, 0.92fr);\n  gap: 28px;\n  padding: 48px;\n  border-radius: 20px;\n  color: #ffffff;\n  background:\n    radial-gradient(circle at 10% 15%, rgba(64, 139, 238, 0.34), transparent 32%),\n    radial-gradient(circle at 88% 82%, rgba(240, 162, 58, 0.2), transparent 29%),\n    linear-gradient(132deg, var(--info-ink) 0%, var(--info-ink-deep) 72%);\n  overflow: hidden;\n  animation: info-rise 420ms ease-out both;\n}\n\n.info-hero::before,\n.info-hero::after {\n  position: absolute;\n  z-index: -1;\n  width: 250px;\n  height: 250px;\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 50%;\n  content: \"\";\n}\n\n.info-hero::before {\n  top: -150px;\n  right: 26%;\n  box-shadow:\n    0 0 0 46px rgba(255, 255, 255, 0.025),\n    0 0 0 92px rgba(255, 255, 255, 0.018);\n}\n\n.info-hero::after {\n  right: -140px;\n  bottom: -165px;\n  box-shadow: 0 0 0 58px rgba(240, 162, 58, 0.04);\n}\n\n.info-hero__copy {\n  align-self: center;\n  max-width: 760px;\n}\n\n.info-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--info-blue);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.info-eyebrow--light {\n  color: #91bcf5;\n}\n\n.info-hero h1 {\n  max-width: 720px;\n  margin: 14px 0 18px;\n  color: #ffffff;\n  font-size: clamp(2.25rem, 4vw, 4.5rem);\n  font-weight: 700;\n  letter-spacing: -0.055em;\n  line-height: 0.98;\n}\n\n.info-hero__lead {\n  max-width: 690px;\n  margin: 0;\n  color: #dce9f9;\n  font-size: 1.05rem;\n  line-height: 1.75;\n}\n\n.info-principles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 28px;\n}\n\n.info-principles span {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  gap: 9px;\n  padding: 8px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.07);\n  color: #f7fbff;\n  font-size: 0.78rem;\n  font-weight: 700;\n  backdrop-filter: blur(8px);\n}\n\n.info-principles svg {\n  color: #81b7fa;\n}\n\n.info-topology {\n  align-self: stretch;\n  margin: 0;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.075);\n  backdrop-filter: blur(12px);\n}\n\n.info-topology figcaption {\n  display: grid;\n  gap: 4px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.info-topology figcaption span {\n  color: #96aeca;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.info-topology figcaption strong {\n  color: #ffffff;\n  font-size: 1.1rem;\n}\n\n.info-topology__rail {\n  display: grid;\n  gap: 0;\n  margin: 0;\n  padding: 16px 0 12px;\n  list-style: none;\n}\n\n.info-topology__rail li {\n  position: relative;\n  display: grid;\n  grid-template-columns: 28px 38px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n  min-height: 58px;\n}\n\n.info-topology__rail li:not(:last-child)::after {\n  position: absolute;\n  top: 49px;\n  bottom: -9px;\n  left: 46px;\n  width: 1px;\n  background: linear-gradient(#6ba6ee, rgba(107, 166, 238, 0.16));\n  content: \"\";\n}\n\n.info-topology__number {\n  color: #7690ae;\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n\n.info-topology__icon {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 11px;\n  background: #17365f;\n  color: #90c0ff;\n}\n\n.info-topology__text {\n  display: grid;\n  gap: 2px;\n}\n\n.info-topology__text strong {\n  color: #ffffff;\n  font-size: 0.86rem;\n}\n\n.info-topology__text small {\n  color: #aebfd3;\n  font-size: 0.72rem;\n  line-height: 1.45;\n}\n\n.info-topology > p {\n  margin: 0;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n  color: #b9c9db;\n  font-size: 0.72rem;\n  line-height: 1.6;\n}\n\n.info-status {\n  grid-column: 1 / -1;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin: 2px 0 0;\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.065);\n  overflow: hidden;\n}\n\n.info-status > div {\n  min-width: 0;\n  padding: 16px 18px;\n}\n\n.info-status > div + div {\n  border-left: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.info-status dt {\n  margin-bottom: 6px;\n  color: #91a8c3;\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.info-status dd {\n  margin: 0;\n  color: #ffffff;\n  font-size: 0.9rem;\n  font-weight: 800;\n  overflow-wrap: anywhere;\n}\n\n.info-status__code {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.78rem !important;\n}\n\n.info-index {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: -38px 28px -20px;\n  padding: 10px;\n  border: 1px solid #dce4ef;\n  border-radius: 14px;\n  background: #f8fafc;\n}\n\n.info-index > span {\n  padding: 8px 12px;\n  color: #64748b;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.info-index a {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  padding: 8px 13px;\n  border-radius: 9px;\n  color: #31445f;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-decoration: none;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.info-index a:hover {\n  background: #eaf2ff;\n  color: #1759ad;\n}\n\n.info-section {\n  min-width: 0;\n  padding: 0 28px;\n  scroll-margin-top: 18px;\n}\n\n.info-section-heading {\n  max-width: 900px;\n  margin-bottom: 24px;\n}\n\n.info-section-heading h2,\n.info-flow h2 {\n  margin: 8px 0 10px;\n  color: var(--info-ink-deep);\n  font-size: clamp(1.65rem, 2.6vw, 2.65rem);\n  font-weight: 700;\n  letter-spacing: -0.04em;\n  line-height: 1.1;\n}\n\n.info-section-heading > p {\n  max-width: 780px;\n  margin: 0;\n  color: #64748b;\n  font-size: 0.95rem;\n  line-height: 1.7;\n}\n\n.info-tool-groups {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.info-tool-group {\n  min-width: 0;\n  padding: 22px;\n  border: 1px solid #dce4ef;\n  border-radius: 18px;\n  background: #fbfdff;\n}\n\n.info-tool-group > header {\n  display: grid;\n  grid-template-columns: 44px minmax(0, 1fr);\n  gap: 14px;\n  min-height: 84px;\n  padding: 0 2px 18px;\n  border-bottom: 1px solid #e5ebf3;\n}\n\n.info-tool-group__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 13px;\n  background: #eaf2ff;\n  color: #1759ad;\n  font-size: 1rem;\n}\n\n.info-tool-group h3 {\n  margin: 1px 0 5px;\n  color: #122b4e;\n  font-size: 1rem;\n}\n\n.info-tool-group header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.76rem;\n  line-height: 1.55;\n}\n\n.info-tool-group ul {\n  display: grid;\n  gap: 4px;\n  margin: 12px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.info-tool-link {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) 22px;\n  min-height: 62px;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 10px;\n  border-radius: 11px;\n  color: inherit;\n  text-decoration: none;\n  transition: background 150ms ease, transform 150ms ease;\n}\n\n.info-tool-link:hover {\n  background: #ffffff;\n  transform: translateX(2px);\n}\n\n.info-tool-link__icon {\n  display: inline-flex;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #dfe7f1;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #3f5b7f;\n}\n\n.info-tool-link__copy {\n  display: grid;\n  min-width: 0;\n  gap: 3px;\n}\n\n.info-tool-link__copy strong {\n  color: #10284a;\n  font-size: 0.82rem;\n}\n\n.info-tool-link__copy small {\n  color: #6d7d91;\n  font-size: 0.68rem;\n  line-height: 1.4;\n}\n\n.info-tool-link__arrow {\n  justify-self: center;\n  color: #94a3b8;\n  font-size: 0.72rem;\n  transition: color 150ms ease, transform 150ms ease;\n}\n\n.info-tool-link:hover .info-tool-link__arrow {\n  color: #1759ad;\n  transform: translateX(2px);\n}\n\n.info-applications {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.info-application {\n  display: grid;\n  grid-template-columns: 142px minmax(0, 1fr);\n  min-height: 190px;\n  border: 1px solid #dce4ef;\n  border-radius: 18px;\n  background: #ffffff;\n  color: inherit;\n  text-decoration: none;\n  overflow: hidden;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.info-application:first-child {\n  grid-column: 1 / -1;\n  grid-template-columns: minmax(190px, 0.55fr) minmax(0, 1.45fr);\n}\n\n.info-application:hover {\n  border-color: #a9c7ec;\n  box-shadow: 0 14px 30px rgba(23, 89, 173, 0.1);\n  transform: translateY(-2px);\n}\n\n.info-application__visual {\n  position: relative;\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 24px;\n  background:\n    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.28), transparent 24%),\n    linear-gradient(145deg, #225f99, #123d69);\n  color: #ffffff;\n  overflow: hidden;\n}\n\n.info-application:nth-child(2) .info-application__visual {\n  background:\n    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.28), transparent 24%),\n    linear-gradient(145deg, #2f8069, #175242);\n}\n\n.info-application:nth-child(3) .info-application__visual {\n  background:\n    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.24), transparent 24%),\n    linear-gradient(145deg, #2466ae, #123c75);\n}\n\n.info-application:nth-child(4) .info-application__visual {\n  background:\n    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.26), transparent 24%),\n    linear-gradient(145deg, #b85e3f, #793725);\n}\n\n.info-application:nth-child(5) .info-application__visual {\n  background:\n    radial-gradient(circle at 86% 15%, rgba(255, 255, 255, 0.26), transparent 24%),\n    linear-gradient(145deg, #5c638d, #333958);\n}\n\n.info-application__visual::after {\n  position: absolute;\n  right: -38px;\n  bottom: -56px;\n  width: 135px;\n  height: 135px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  box-shadow: 0 0 0 26px rgba(255, 255, 255, 0.04);\n  content: \"\";\n}\n\n.info-application__visual > svg {\n  position: relative;\n  z-index: 1;\n  font-size: 1.75rem;\n}\n\n.info-application__visual small {\n  position: relative;\n  z-index: 1;\n  color: rgba(255, 255, 255, 0.83);\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.09em;\n  line-height: 1.45;\n  text-transform: uppercase;\n}\n\n.info-application__body {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  padding: 24px;\n}\n\n.info-application__title {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.info-application__title strong {\n  color: #0b203c;\n  font-size: 1rem;\n}\n\n.info-application__title svg {\n  margin-top: 3px;\n  color: #94a3b8;\n  font-size: 0.72rem;\n  transition: color 150ms ease, transform 150ms ease;\n}\n\n.info-application:hover .info-application__title svg {\n  color: #1759ad;\n  transform: translateX(2px);\n}\n\n.info-application__description {\n  margin-top: 10px;\n  color: #56677c;\n  font-size: 0.76rem;\n  line-height: 1.65;\n}\n\n.info-application__data {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: auto;\n  padding-top: 15px;\n  color: #46617f;\n  font-size: 0.66rem;\n  font-weight: 700;\n  line-height: 1.45;\n}\n\n.info-application__data svg {\n  flex: 0 0 auto;\n  margin-top: 2px;\n  color: #3a78c2;\n}\n\n.info-flow {\n  display: grid;\n  grid-template-columns: minmax(260px, 0.72fr) minmax(0, 1.28fr);\n  gap: 42px;\n  margin: 0 28px;\n  padding: 40px;\n  border-radius: 20px;\n  color: #ffffff;\n  background:\n    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px),\n    #0c213e;\n  background-size: 32px 32px;\n  scroll-margin-top: 18px;\n}\n\n.info-flow__intro {\n  align-self: start;\n  position: sticky;\n  top: 18px;\n}\n\n.info-flow h2 {\n  margin-top: 10px;\n  color: #ffffff;\n}\n\n.info-flow__intro p {\n  margin: 0;\n  color: #b8c8dc;\n  font-size: 0.8rem;\n  line-height: 1.7;\n}\n\n.info-flow__steps {\n  display: grid;\n  gap: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.info-flow__steps li {\n  display: grid;\n  grid-template-columns: 54px minmax(0, 1fr);\n  gap: 18px;\n  padding: 19px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.11);\n}\n\n.info-flow__steps li:first-child {\n  padding-top: 0;\n}\n\n.info-flow__steps li:last-child {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n\n.info-flow__number {\n  display: inline-flex;\n  width: 42px;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(131, 184, 251, 0.35);\n  border-radius: 12px;\n  background: rgba(76, 142, 224, 0.12);\n  color: #8dc0ff;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n\n.info-flow__steps h3 {\n  margin: 1px 0 5px;\n  color: #ffffff;\n  font-size: 0.9rem;\n}\n\n.info-flow__steps p {\n  margin: 0;\n  color: #b8c8dc;\n  font-size: 0.72rem;\n  line-height: 1.6;\n}\n\n.info-boundaries {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  border: 1px solid #dce4ef;\n  border-radius: 18px;\n  overflow: hidden;\n}\n\n.info-boundaries article {\n  position: relative;\n  min-width: 0;\n  padding: 26px;\n  background: #ffffff;\n}\n\n.info-boundaries article + article {\n  border-left: 1px solid #dce4ef;\n}\n\n.info-boundaries article:nth-child(odd) {\n  border-left: 0;\n}\n\n.info-boundaries article:nth-child(n + 3) {\n  border-top: 1px solid #dce4ef;\n}\n\n.info-boundaries__icon {\n  display: inline-flex;\n  width: 42px;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 22px;\n  border-radius: 12px;\n  background: #eaf2ff;\n  color: #1759ad;\n}\n\n.info-boundaries__label {\n  display: block;\n  margin-bottom: 6px;\n  color: #6782a3;\n  font-size: 0.63rem;\n  font-weight: 800;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n}\n\n.info-boundaries h3 {\n  margin: 0 0 10px;\n  color: #10284a;\n  font-size: 1rem;\n}\n\n.info-boundaries p {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.72rem;\n  line-height: 1.65;\n}\n\n.info-privacy-note {\n  display: grid;\n  grid-template-columns: 42px minmax(0, 1fr);\n  gap: 14px;\n  margin-top: 14px;\n  padding: 18px 20px;\n  border: 1px solid #cfe0f5;\n  border-radius: 14px;\n  background: #f2f7fd;\n  color: #10284a;\n}\n\n.info-privacy-note > svg {\n  justify-self: center;\n  margin-top: 2px;\n  color: #1759ad;\n  font-size: 1rem;\n}\n\n.info-privacy-note strong {\n  font-size: 0.8rem;\n}\n\n.info-privacy-note p {\n  margin: 4px 0 0;\n  color: #59708d;\n  font-size: 0.7rem;\n  line-height: 1.55;\n}\n\n.info-scope {\n  display: grid;\n  grid-template-columns: minmax(220px, 0.45fr) minmax(0, 1.55fr);\n  gap: 28px;\n  margin-top: 14px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #fbfcfe;\n}\n\n.info-scope__heading h3 {\n  margin: 8px 0 0;\n  color: #10284a;\n  font-size: 1rem;\n  line-height: 1.35;\n}\n\n.info-scope ul {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px 24px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.info-scope li {\n  position: relative;\n  padding-left: 17px;\n  color: #607188;\n  font-size: 0.69rem;\n  line-height: 1.6;\n}\n\n.info-scope li::before {\n  position: absolute;\n  top: 0.65em;\n  left: 0;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #3f7fc9;\n  content: \"\";\n}\n\n.info-section--terms {\n  padding-bottom: 12px;\n}\n\n.info-glossary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0;\n  margin: 0;\n  border-top: 1px solid #dce4ef;\n  border-left: 1px solid #dce4ef;\n}\n\n.info-glossary > div {\n  min-width: 0;\n  min-height: 142px;\n  padding: 22px;\n  border-right: 1px solid #dce4ef;\n  border-bottom: 1px solid #dce4ef;\n  background: #ffffff;\n}\n\n.info-glossary dt {\n  margin-bottom: 9px;\n  color: #10284a;\n  font-size: 0.92rem;\n  font-weight: 800;\n}\n\n.info-glossary dd {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.7rem;\n  line-height: 1.65;\n}\n\n.info-page a:focus-visible {\n  outline: 3px solid rgba(59, 130, 246, 0.36);\n  outline-offset: 3px;\n}\n\n@keyframes info-rise {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 1180px) {\n  .info-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .info-topology__rail {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 10px;\n  }\n\n  .info-topology__rail li {\n    grid-template-columns: 32px minmax(0, 1fr);\n    grid-template-rows: auto auto;\n    align-content: start;\n    min-height: 110px;\n    padding: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n  }\n\n  .info-topology__rail li::after {\n    display: none;\n  }\n\n  .info-topology__number {\n    grid-column: 1 / -1;\n  }\n\n  .info-topology__text small {\n    margin-top: 2px;\n  }\n}\n\n@media (max-width: 960px) {\n  .info-shell {\n    gap: 52px;\n  }\n\n  .info-hero {\n    padding: 36px;\n  }\n\n  .info-status {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .info-status > div:nth-child(3) {\n    border-left: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.12);\n  }\n\n  .info-status > div:nth-child(4) {\n    border-top: 1px solid rgba(255, 255, 255, 0.12);\n  }\n\n  .info-tool-groups,\n  .info-applications,\n  .info-flow {\n    grid-template-columns: 1fr;\n  }\n\n  .info-application:first-child {\n    grid-column: auto;\n    grid-template-columns: 142px minmax(0, 1fr);\n  }\n\n  .info-flow__intro {\n    position: static;\n  }\n\n  .info-boundaries,\n  .info-glossary {\n    grid-template-columns: 1fr;\n  }\n\n  .info-scope {\n    grid-template-columns: 1fr;\n  }\n\n  .info-boundaries article + article {\n    border-top: 1px solid #dce4ef;\n    border-left: 0;\n  }\n\n  .info-glossary > div {\n    min-height: auto;\n  }\n}\n\n@media (max-width: 720px) {\n  .info-shell {\n    gap: 42px;\n    padding: 10px 10px 30px;\n    border-radius: 20px;\n  }\n\n  .info-hero {\n    gap: 20px;\n    padding: 26px;\n    border-radius: 15px;\n  }\n\n  .info-hero h1 {\n    font-size: clamp(2rem, 11vw, 3.25rem);\n  }\n\n  .info-principles {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .info-topology__rail {\n    grid-template-columns: 1fr;\n  }\n\n  .info-topology__rail li {\n    grid-template-columns: 28px 38px minmax(0, 1fr);\n    grid-template-rows: auto;\n    min-height: 58px;\n    padding: 6px 0;\n    border: 0;\n  }\n\n  .info-topology__number {\n    grid-column: auto;\n  }\n\n  .info-index {\n    margin: -24px 12px -12px;\n  }\n\n  .info-index > span {\n    width: 100%;\n  }\n\n  .info-section {\n    padding: 0 12px;\n  }\n\n  .info-flow {\n    gap: 30px;\n    margin: 0 12px;\n    padding: 28px;\n  }\n\n  .info-tool-group {\n    padding: 16px;\n  }\n\n  .info-scope ul {\n    grid-template-columns: 1fr;\n  }\n\n  .info-application,\n  .info-application:first-child {\n    grid-template-columns: 112px minmax(0, 1fr);\n  }\n\n  .info-application__visual,\n  .info-application__body {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .info-status {\n    grid-template-columns: 1fr;\n  }\n\n  .info-status > div + div,\n  .info-status > div:nth-child(3) {\n    border-top: 1px solid rgba(255, 255, 255, 0.12);\n    border-left: 0;\n  }\n\n  .info-topology {\n    padding: 18px;\n  }\n\n  .info-application,\n  .info-application:first-child {\n    grid-template-columns: 1fr;\n  }\n\n  .info-application__visual {\n    min-height: 112px;\n  }\n\n  .info-application__visual small {\n    margin-top: 22px;\n  }\n\n  .info-tool-group > header {\n    grid-template-columns: 1fr;\n  }\n\n  .info-tool-link {\n    grid-template-columns: 34px minmax(0, 1fr);\n  }\n\n  .info-tool-link__arrow {\n    display: none;\n  }\n\n  .info-flow__steps li {\n    grid-template-columns: 42px minmax(0, 1fr);\n    gap: 12px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .info-hero {\n    animation: none;\n  }\n\n  .info-index a,\n  .info-tool-link,\n  .info-tool-link__arrow,\n  .info-application,\n  .info-application__title svg {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
